import { userService } from '@/services';

const state = {
    all: {},
    user: {}
};

const actions = {
    getAll({ commit }) {
        commit('getAllRequest');

        userService.getAll()
            .then(
                users => commit('getAllSuccess', users),
                error => commit('getAllFailure', error)
            );
    },
    profile({ commit }, id) {
        commit('getUserProfile');
        userService.getLoggedInUser(id)
          .then(
            user => {
                commit('profileSuccess', user);
            },
            error => commit('profileFailure', { id, error: error.toString() })
          );
    },
    delete({ commit }, id) {
        commit('deleteRequest', id);

        userService.delete(id)
            .then(
                user => commit('deleteSuccess', id),
                error => commit('deleteFailure', { id, error: error.toString() })
            );
    },

    async updatePreferences({ }, params) {
        return await userService.updatePreferences(params);
      },
};

const mutations = {
    getAllRequest(state) {
        state.all = { loading: true };
    },
    getUserProfile(state) {
        state.user = { loading: true };
    },
    profileSuccess(state, user) {
        state.user = user;
    },
    profileFailure(state, error) {
        state.all = { error };
    },
    getAllSuccess(state, users) {
        state.all = { items: users };
    },
    getAllFailure(state, error) {
        state.all = { error };
    },
    deleteRequest(state, id) {
        // add 'deleting:true' property to user being deleted
        state.all.items = state.all.items.map(user =>
            user.id === id
                ? { ...user, deleting: true }
                : user
        )
    },
    deleteSuccess(state, id) {
        // remove deleted user from state
        state.all.items = state.all.items.filter(user => user.id !== id)
    },
    deleteFailure(state, { id, error }) {
        // remove 'deleting:true' property and add 'deleteError:[error]' property to user
        state.all.items = state.items.map(user => {
            if (user.id === id) {
                // make copy of user without 'deleting:true' property
                const { deleting, ...userCopy } = user;
                // return copy of user with 'deleteError:[error]' property
                return { ...userCopy, deleteError: error };
            }

            return user;
        })
    }
};

export const users = {
    namespaced: true,
    state,
    actions,
    mutations
};
